module.exports = __webpack_public_path__ + "static/media/03.f4e6ef1b.jpg";